import React, { useEffect, useRef, useState } from "react";
import {
  createInbound,
  deleteInbound,
  fetchAllInbound,
  fetchInboundByRFID,
  checkRFID,
} from "../../resources/InboundResource";
import { fetchAllRack } from "../../resources/RackResource";
import DataTable from "react-data-table-component";
import { format } from "date-fns";
import { showSuccessToast } from "../../utils/GlobalToast";
import Select from "react-select";
import { getLocalAuth } from "../../utils/AuthUtils";
import ErrorNotFound from "../errors/Error";

function Inbound() {
  const values = getLocalAuth();
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilege = privilege.data.menu.filter((data) => {
    return data.code === "Inbound";
  });

  let dataRead =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
          return data.code === "Read";
        });

  let dataCreate =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
          return data.code === "Create";
        });

  let dataDelete =
    dataPrivilege.length === 0
      ? []
      : dataPrivilege[0].action_page.filter((data) => {
          return data.code === "Delete";
        });

  const [dataInbound, setDataInbound] = useState([]);
  const [dataRack, setDataRack] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const [rfid, setRfid] = useState("");
  const [qrSap, setQrSap] = useState("");
  const [part, setPart] = useState("");
  const [productionDate, setProductionDate] = useState("");
  const [qty, setQty] = useState(1);
  const [batch, setBatch] = useState("");
  const [shift, setShift] = useState("");
  const [tracking, setTracking] = useState("");
  const [rackId, setRackId] = useState("default");
  const [registeredRFID, setRegisteredRFID] = useState([]);

  const [dateFilter, setDateFilter] = useState("");

  const [idEdit, setIdEdit] = useState(null);

  const [isError, setIsError] = useState(false);
  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [error, setError] = useState("");
  const [errorDelete, setErrorDelete] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const inputRef = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const [activeInput, setActiveInput] = useState("");

  const fetchInbound = () => {
    fetchAllInbound(
      dateFilter === "" ? "" : format(dateFilter, "yyyy-MM-dd").toString()
    )
      .then((res) => {
        setDataInbound(res.data);
      })
      .catch((err) => {
        setDataInbound([]);
      });
  };

  const fetchRack = () => {
    fetchAllRack()
      .then((res) => {
        setDataRack(res.data);
      })
      .catch((err) => {
        setDataRack([]);
      });
  };

  useEffect(() => {
    fetchInbound();
    fetchRack();

    // eslint-disable-next-line
  }, [refreshKey]);

  let dataRackSelect = dataRack.map(function (data) {
    return { value: data.id, label: data.name };
  });

  const handleSubmit = () => {
    postInbound(
      registeredRFID,
      part,
      qrSap,
      productionDate,
      qty,
      batch,
      shift,
      tracking,
      rackId
    );
  };

  const postInbound = (
    registeredRFID,
    part,
    qrSap,
    productionDate,
    qty,
    batch,
    shift,
    tracking,
    rackId
  ) => {
    if (!qrSap) {
      setIsLoading(false);
      setError("QR SAP cannot be empty!");
      setIsError(true);
    } else if (registeredRFID.length !== qty) {
      setIsLoading(false);
      setError("Your RFID amount is not match with quantity!");
      setIsError(true);
    } else {
      setIsLoading(true);
      // console.log({
      //   registeredRFID: registeredRFID.map((e) => e.title),
      //   part: part,
      //   qrSap: qrSap,
      //   productionDate: productionDate,
      //   qty: qty,
      //   batch: batch,
      //   shift: shift,
      //   tracking: tracking,
      //   rackId: rackId.value,
      // });
      createInbound(
        registeredRFID.map((e) => e.title),
        part,
        qrSap,
        productionDate,
        qty,
        batch,
        shift,
        tracking,
        rackId.value
      )
        .then((res) => {
          setIsLoading(false);
          setIsError(false);
          showSuccessToast("Success Added Inbound!");
          setShowAddModal(false);
          setRfid("");
          setRegisteredRFID([]);
          setPart("");
          setQrSap("");
          setProductionDate("");
          setQty(0);
          setBatch("");
          setShift("");
          setTracking("");
          setRackId("default");
          fetchInbound();
        })
        .catch((err) => {
          setIsLoading(false);
          console.error(err);
          setError(
            typeof err === "undefined"
              ? "There was an error checking your connection or input"
              : err
          );
          setIsError(true);
        });
    }
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter") {
      if (!rfid) {
        setError("RFID cannot be empty!");
        setIsError(true);
      } else if (registeredRFID.some((e) => e.title === rfid)) {
        setError(`RFID: ${rfid} has been added!`);
        setIsError(true);
        setRfid("");
      } else {
        checkRFID(rfid).then((res) => {
          // console.log(res);
          if (res?.result) {
            setRegisteredRFID([...registeredRFID, { title: rfid }]);
            setRfid("");
            setIsError(false);
          } else {
            setError(res?.message);
            setIsError(true);
            setRfid("");
          }
        });
        // const listInbound = await fetchInboundByRFID(rfid)
        //   .then((res) => {
        //     return res;
        //   })
        //   .catch((err) => {
        //     setError(`RFID: ${rfid} not register!`);
        //     setIsError(true);
        //   });
        // // const listRegister = await fetchInboundByRFID(rfid);
        // console.log(listInbound);

        // if (listInbound?.data) {
        //   setError(`RFID: ${rfid} has been used!`);
        //   setIsError(true);
        // } else if (!listInbound) {
        //   setError(`RFID: ${rfid} not yet register!`);
        //   setIsError(true);
        // } else {
        // setRegisteredRFID([...registeredRFID, { title: rfid }]);
        // setRfid("");
        // }
      }
      // setTimeout(() => {
      //   if (inputRef2.current) {
      //     inputRef2.current.focus();
      //   }
      // }, 200);
    }
  };

  const handleKeyDown2 = (event) => {
    if (event.key === "Enter") {
      if (qrSap) {
        let result = qrSap.split("|");
        if (result.length > 5) {
          setBatch(result[0]);
          setTracking(result[1]);
          setProductionDate(result[2]);
          setShift(result[3]);
          setPart(result[7]);
          setQty(Math.round(result[8]));
        } else {
          setPart(result[0]);
          setBatch(result[2]);
          setProductionDate(result[3]);
          setQty(Math.round(result[4]));
          setTracking("");
          setShift("");
        }

        setTimeout(() => {
          if (inputRef3.current) {
            inputRef3.current.focus();
          }
        }, 200);
      }
    }
  };

  const handleData = (data) => {
    setIdEdit(data.id);
  };

  const handleDelete = () => {
    setIsLoading(true);
    deleteInbound(idEdit)
      .then((res) => {
        setIsLoading(false);
        setIsErrorDelete(false);
        showSuccessToast("Success Deleted Inbound!");
        setShowDeleteModal(false);
        fetchInbound();
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorDelete(err);
        setIsErrorDelete(true);
      });
  };

  const onChangeRfid = (e) => {
    setRfid(e.target.value);
  };

  const onChangeQrSap = (e) => {
    setQrSap(e.target.value);
  };

  const onChangeHandlerRack = (options) => {
    setRackId(options);
  };

  const columns = [
    {
      name: "No",
      cell: (row, index) => index + 1,
      width: "60px",
    },
    {
      name: "RFID",
      selector: (row) => row.rfid.name,
      sortable: true,
    },
    {
      name: "QR SAP",
      selector: (row) => row.qr_sap,
      sortable: true,
      width: "250px",
    },
    {
      name: "Part No",
      selector: (row) => row.part.part_number,
      sortable: true,
      width: "150px",
    },
    {
      name: "Part Name",
      selector: (row) => row.part.name,
      sortable: true,
      width: "150px",
    },
    {
      name: "Batch",
      selector: (row) => row.batch,
      sortable: true,
      width: "150px",
    },
    {
      name: "Production Date",
      selector: (row) => row.production_date ? format(row.production_date, "yyyy-MM-dd").toString() : null,
      sortable: true,
      width: "150px",
    },
    {
      name: "QTY",
      selector: (row) => row.qty,
      sortable: true,
      width: "100px",
    },
    {
      name: "Rack",
      selector: (row) => row.rack.name,
      sortable: true,
      width: "150px",
    },
    {
      name: "Scan Date",
      selector: (row) =>
        format(row.datetime_scan, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
      width: "150px",
    },
    {
      name: "Scanned By",
      selector: (row) => row?.user?.name,
      sortable: true,
      width: "150px",
    },
    {
      name: "Actions",
      width: "150px",
      cell: (row) => (
        <>
          {dataDelete.length === 0 ? (
            <div></div>
          ) : !dataDelete[0].is_active ? (
            <div></div>
          ) : (
            <button
              type="button"
              style={{ marginRight: "8px" }}
              className="btn btn-danger"
              onClick={() => {
                handleData(row);
                setShowDeleteModal(true);
              }}
            >
              Delete
            </button>
          )}
          <div
            className={`modal fade ${showDeleteModal ? "show" : ""}`}
            style={{
              display: showDeleteModal ? "block" : "none",
              backgroundColor: "rgba(0, 0, 0, 0.1)",
            }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete this data?</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                    aria-label="Close"
                  ></button>
                </div>
                {isErrorDelete ? (
                  <div
                    style={{
                      paddingLeft: "16px",
                      paddingRight: "16px",
                      paddingTop: "16px",
                      paddingBottom: "0px",
                    }}
                  >
                    <div
                      className="alert alert-danger alert-dismissible fade show"
                      role="alert"
                    >
                      {errorDelete}
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="alert"
                        aria-label="Close"
                        onClick={() => setIsErrorDelete(false)}
                      ></button>
                    </div>
                  </div>
                ) : null}
                <div className="modal-body">You will delete this Inbound</div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    Cancel
                  </button>
                  {!isLoading ? (
                    <button
                      type="submit"
                      className="btn btn-danger"
                      onClick={() => handleDelete()}
                    >
                      Delete
                    </button>
                  ) : (
                    <button className="btn btn-danger" type="button" disabled>
                      {" "}
                      <span
                        style={{ marginRight: "4px" }}
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loading...
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div>
      {dataRead.length === 0 ? (
        <ErrorNotFound />
      ) : !dataRead[0].is_active ? (
        <ErrorNotFound />
      ) : (
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row">
                    <div className="col-md-10">
                      <h4 className="mb-0">Inbound</h4>
                    </div>
                    <div className="col-md-2 text-end d-grid">
                      {dataCreate.length === 0 ? (
                        <div></div>
                      ) : !dataCreate[0].is_active ? (
                        <div></div>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-info ms-auto radius-10"
                          onClick={() => {
                            setShowAddModal(true);
                            setTimeout(() => {
                              if (inputRef2.current) {
                                inputRef2.current.focus();
                              }
                            }, 200);
                          }}
                        >
                          <i className="bx bx-plus"></i> Inbound
                        </button>
                      )}
                    </div>
                    <div
                      id="modal"
                      className={`modal fade ${showAddModal ? "show" : ""}`}
                      style={{
                        display: showAddModal ? "block" : "none",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                      }}
                    >
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Inbound</h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => {
                                setShowAddModal(false);
                                setIsLoading(false);
                                setIsError(false);
                                setRfid("");
                                setRegisteredRFID([]);
                                setPart("");
                                setQrSap("");
                                setProductionDate("");
                                setQty(1);
                                setBatch("");
                                setShift("");
                                setTracking("");
                                setRackId("default");
                              }}
                              aria-label="Close"
                            ></button>
                          </div>
                          {isError ? (
                            <div
                              style={{
                                paddingLeft: "16px",
                                paddingRight: "16px",
                                paddingTop: "16px",
                                paddingBottom: "0px",
                              }}
                            >
                              <div
                                className="alert alert-danger alert-dismissible fade show"
                                role="alert"
                              >
                                {error}
                                <button
                                  type="button"
                                  className="btn-close"
                                  data-bs-dismiss="alert"
                                  aria-label="Close"
                                  onClick={() => setIsError(false)}
                                ></button>
                              </div>
                            </div>
                          ) : null}
                          <div className="modal-body">
                            <form>
                              {/* <div className="mb-3">
                                <label className="form-label fw-bold">
                                  RFID
                                </label>
                                <input
                                  required
                                  autoFocus
                                  ref={inputRef}
                                  type="text"
                                  className="form-control"
                                  value={rfid}
                                  onKeyDown={handleKeyDown}
                                  onChange={(e) => onChangeRfid(e)}
                                  placeholder="Scan here..."
                                />
                              </div> */}
                              <div className="mb-3">
                                <label className="form-label fw-bold">
                                  QR SAP Lot Control
                                </label>
                                <input
                                  required
                                  ref={inputRef2}
                                  type="text"
                                  className="form-control"
                                  value={qrSap}
                                  onKeyDown={handleKeyDown2}
                                  // onFocus={() => setQrSap("")}
                                  onChange={(e) => onChangeQrSap(e)}
                                  placeholder="Scan here..."
                                />
                              </div>
                              <div className="mb-3">
                                <div className="row g-3">
                                  <div className="col-md-5">
                                    <label className="form-label fw-bold">
                                      Part
                                    </label>
                                    <input
                                      required
                                      disabled
                                      type="text"
                                      className="form-control"
                                      value={part}
                                      onChange={(e) => setPart(e.target.value)}
                                    />
                                  </div>

                                  {/* Batch dan Qty pindah Row */}
                                  <div className="col-md-4">
                                    <label className="form-label fw-bold">
                                      Batch
                                    </label>
                                    <input
                                      required
                                      disabled
                                      type="text"
                                      className="form-control"
                                      value={batch}
                                      onChange={(e) => setBatch(e.target.value)}
                                    />
                                  </div>
                                  <div className="col-md-3">
                                    <label className="form-label fw-bold">
                                      Quantity
                                    </label>
                                    <input
                                      required
                                      disabled
                                      type="number"
                                      className="form-control"
                                      value={qty}
                                      onChange={(e) => setQty(e.target.value)}
                                    />
                                  </div>

                                  {/* <div className="col-md-6">
                                    <label className="form-label fw-bold">
                                      Production Date
                                    </label>
                                    <input
                                      required
                                      disabled
                                      type="text"
                                      className="form-control"
                                      value={productionDate}
                                      onChange={(e) =>
                                        setProductionDate(e.target.value)
                                      }
                                    />
                                  </div> */}
                                </div>
                              </div>
                              {/* <div className="mb-3">
                              <div className="row g-3">

                              </div>
                              </div> */}
                              {/* <div className="mb-3">
                                <div className="row g-3">
                                  <div className="col-md-6">
                                    <label className="form-label fw-bold">
                                      Shift
                                    </label>
                                    <input
                                      required
                                      disabled
                                      type="text"
                                      className="form-control"
                                      value={shift}
                                      onChange={(e) => setShift(e.target.value)}
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <label className="form-label fw-bold">
                                      Tracking
                                    </label>
                                    <input
                                      required
                                      disabled
                                      type="text"
                                      className="form-control"
                                      value={tracking}
                                      onChange={(e) =>
                                        setTracking(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                              </div> */}
                              {/* <div className="mb-3">
                                <label className="form-label fw-bold">
                                  Rack Location
                                </label>
                                <Select
                                  value={rackId}
                                  onChange={onChangeHandlerRack}
                                  options={dataRackSelect}
                                />
                              </div> */}
                              <hr />
                              <div className="mb-3">
                                <label className="form-label fw-bold">
                                  Register RFID
                                </label>
                                <div className="row">
                                  <div className="col-md-12">
                                    <input
                                      required
                                      autoFocus
                                      ref={inputRef3}
                                      type="text"
                                      className="form-control "
                                      value={rfid}
                                      onKeyDown={handleKeyDown}
                                      onChange={(e) => onChangeRfid(e)}
                                      placeholder="Scan here..."
                                    />
                                  </div>
                                  {/* <div className="col-md-2">
                                    <button
                                      type="button"
                                      className="btn btn-info"
                                      onClick={() => {
                                        setRegisteredRFID([
                                          ...registeredRFID,
                                          { title: rfid },
                                        ]);
                                        setRfid("");
                                      }}
                                    >
                                      Add
                                    </button>
                                  </div> */}
                                </div>
                              </div>
                              <div
                                style={{
                                  width: "200px",
                                  color: "#FFF",
                                  backgroundColor:
                                    registeredRFID.length === qty
                                      ? "#32ab13"
                                      : "tomato",
                                  borderRadius: "8px",
                                  paddingLeft: "16px",
                                  paddingRight: "16px",
                                  paddingBottom: "8px",
                                  paddingTop: "8px",
                                  textAlign: "center",
                                }}
                              >{`${registeredRFID.length} Scanned`}</div>

                              <div className="table-responsive">
                                <DataTable
                                  columns={[
                                    {
                                      name: "RFID",
                                      width: "70%",
                                      selector: (row) => row.title,
                                    },
                                    {
                                      name: "Action",
                                      width: "30%",
                                      selector: (row) => (
                                        <button
                                          type="button"
                                          className="btn btn-danger"
                                          onClick={() =>
                                            setRegisteredRFID(
                                              registeredRFID.filter(
                                                (e) => e.title !== row.title
                                              )
                                            )
                                          }
                                        >
                                          Delete
                                        </button>
                                      ),
                                    },
                                  ]}
                                  data={registeredRFID}
                                />
                              </div>
                              <br></br>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={() => {
                                    setShowAddModal(false);
                                    setIsLoading(false);
                                    setIsError(false);
                                    setRfid("");
                                    setRegisteredRFID([]);
                                    setPart("");
                                    setQrSap("");
                                    setProductionDate("");
                                    setQty(1);
                                    setBatch("");
                                    setShift("");
                                    setTracking("");
                                    setRackId("default");
                                  }}
                                >
                                  Cancel
                                </button>
                                {!isLoading ? (
                                  <button
                                    type="button"
                                    className="btn btn-info"
                                    onClick={() => handleSubmit()}
                                  >
                                    Submit
                                  </button>
                                ) : (
                                  <button
                                    className="btn btn-info"
                                    type="button"
                                    disabled
                                  >
                                    {" "}
                                    <span
                                      style={{ marginRight: "4px" }}
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Loading...
                                  </button>
                                )}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label">Scan Date:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dateFilter}
                      onChange={(e) => {
                        setDateFilter(e.target.value);
                        setRefreshKey((refreshKey) => refreshKey + 1);
                      }}
                    />
                  </div>
                </div>
                <br />
                <div className="table-responsive">
                  <DataTable columns={columns} data={dataInbound} pagination />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Inbound;
